import style from '../FeatureFeedback.module.less';
import Translations from '../../../utils/Translations.js';

const FeatureFeedbackPanelResult = () => (
	<div className={style.featureFeedbackPanelResult}>
		<i className="icon -icon-round-success-full h-color-success -size-sm" />
		&nbsp;{Translations.get('FeatureFeedbackSuccessMessageSingle')}
	</div>
);

export default FeatureFeedbackPanelResult;
